export const categories = [
  {
    id: 'necklaces',
    name: 'Necklaces',
    description: 'Elegant necklaces for every occasion',
    image: 'https://images.unsplash.com/photo-1599643477877-530eb83abc8e?q=80&w=1000',
  },
  {
    id: 'earrings',
    name: 'Earrings',
    description: 'Beautiful earrings to complement your style',
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3Do',
  },
  {
    id: 'bangles',
    name: 'Bangles & Bracelets',
    description: 'Traditional and modern bangles collection',
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?q=80&w=1000',
  },
  {
    id: 'rings',
    name: 'Rings',
    description: 'Stunning rings for every finger',
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=1000',
  },
  {
    id: 'anklets',
    name: 'Anklets',
    description: 'Beautiful anklets for traditional wear',
    image: 'https://images.unsplash.com/photo-1738696692817-247150cdba2c?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  }
];

export const products = [
  {
    id: 'nk1',
    name: 'Royal Kundan Necklace',
    description: 'Elegant kundan necklace with pearl details',
    price: 2999,
    category: 'necklaces',
    images: ['https://images.unsplash.com/photo-1599643477877-530eb83abc8e?q=80&w=1000'],
    featured: true
  },
  {
    id: 'er1',
    name: 'Crystal Drop Earrings',
    description: 'Sparkling crystal earrings with gold plating',
    price: 1299,
    category: 'earrings',
    images: ['https://themillenniumbride.com/cdn/shop/products/il_fullxfull.4105139018_16pf.jpg?v=1681416842'],
    featured: true
  },
  {
    id: 'bg1',
    name: 'Traditional Bangles Set',
    description: 'Set of 6 traditional bangles with meenakari work',
    price: 1599,
    category: 'bangles',
    images: ['https://images.unsplash.com/photo-1611591437281-460bfbe1220a?q=80&w=1000'],
    featured: true
  },
  {
    id: 'rg1',
    name: 'Antique Style Ring',
    description: 'Antique finish ring with pearl center',
    price: 899,
    category: 'rings',
    images: ['https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=1000'],
    featured: true
  },
  {
    id: 'nk2',
    name: 'Pearl Choker Necklace',
    description: 'Elegant pearl choker with gold finish',
    price: 1999,
    category: 'necklaces',
    images: ['https://images.unsplash.com/photo-1599459183200-59c7687a0275?q=80&w=1000'],
    featured: true
  },
  {
    id: 'er2',
    name: 'Jhumka Earrings',
    description: 'Traditional jhumka with pearl drops',
    price: 1499,
    category: 'earrings',
    images: ['https://rimli.in/cdn/shop/files/Drisa_Antique_Jhumka_Earrings_Green_non_silver_rimli_02.webp?v=1727158318&width=1200'],
    featured: true
  },
  {
    id: 'bg2',
    name: 'Gold Plated Kada',
    description: 'Broad kada with traditional design',
    price: 1899,
    category: 'bangles',
    images: ['https://images.unsplash.com/photo-1602752250015-52934bc45613?q=80&w=1000'],
    featured: true
  },
  {
    id: 'rg2',
    name: 'Statement Cocktail Ring',
    description: 'Large cocktail ring with colored stones',
    price: 1299,
    category: 'rings',
    images: ['https://images.unsplash.com/photo-1603561596112-0a132b757442?q=80&w=1000'],
    featured: true
  },
  {
    id: 'nk3',
    name: 'Layered Necklace Set',
    description: 'Modern layered necklace with matching earrings',
    price: 2499,
    category: 'necklaces',
    images: ['https://zariin.com/cdn/shop/files/ASRN728_2_75202d1e-283e-4357-96e8-6bacb6bd5162.jpg?v=1737522952'],
    featured: true
  },
  {
    id: 'er3',
    name: 'Pearl Studs',
    description: 'Classic pearl studs with crystal accents',
    price: 999,
    category: 'earrings',
    images: ['https://blingbox.in/cdn/shop/files/w54.jpg?v=1699122239&width=1080'],
    featured: true
  },
  {
    id: 'bg3',
    name: 'Stone Studded Bracelet',
    description: 'Elegant bracelet with colored stones',
    price: 1699,
    category: 'bangles',
    images: ['https://images.unsplash.com/photo-1611591437281-460bfbe1220a?q=80&w=1000'],
    featured: true
  },
  {
    id: 'rg3',
    name: 'Traditional Ring Set',
    description: 'Set of 3 traditional rings',
    price: 1599,
    category: 'rings',
    images: ['https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=1000'],
    featured: true
  }
];